import { AutocompleteInput, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Landmark } from "lucide-react";
import { Create, ReferenceInput, SimpleForm, TextInput } from "../common";

const DepartmentToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Department" />
  </div>
);

export const DepartmentCreate = () => (
  <Create title="Create Department">
    <Card className="form-container">
      <div className="form-header-premium">
        <Landmark className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Add New Department</h2>
      </div>
      <SimpleForm toolbar={<DepartmentToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="name" label="Department Name" />
          <TextInput source="code" label="Department Code" />
          <ReferenceInput source="head_employee_id" reference="employees">
            <AutocompleteInput label="Department Head" optionText="name" />
          </ReferenceInput>
        </div>
      </SimpleForm>
    </Card>
  </Create>
);

